import React, { useEffect } from 'react';
import './../PerformanceCard.css'; // Assuming you will style the component similarly to TradeCard
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScriptIcon from './ScriptIcon';
import { isMiniLot } from '../utils/lotVariant';

const PerformanceCard = ({ performance, isDarkMode = false }) => {
    
    // useEffect(() => {
    //     console.log("PerformanceCard performance: ", performance.closeType);
    //   }, []);

    if (!performance) return null;

    const lotVariant = String(
      performance.lotVariant || performance.closing_order?.lotVariant || ''
    ).toUpperCase();
    const pnlNum = Number(performance.pnl) || 0;
    const pnlColor = pnlNum > 0 ? "green" : "red";
    const buySell = String(performance.buy_sell ?? '');
    const quantityColor = buySell === '1' ? 'green' : 'red';

    const isBuy = buySell === '1';
    const qtyValue = Number(performance.orderQuantity ?? 0).toFixed(2);
    const openPrice = Number(performance.orderPrice || 0).toFixed(2);
    const closePrice = Number(performance.entryPrice || 0).toFixed(2);
    const isAutoExit = String(performance.closeType) === '1';
    const orderTypeKey = String(performance.orderType || '1');
    const typeLabel = isAutoExit
      ? 'Auto Exit'
      : orderTypeKey === '2'
        ? 'LIMIT'
        : orderTypeKey !== '1'
          ? 'SL'
          : '';

    return (
        <div className={`position-card ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
            <div className="d-flex justify-content-between align-items-center position-card-top">
                <div>
                    <h4 className="position-scriptName">
                        <ScriptIcon name={performance.stockName} size={28} />
                        <span className="script-identity-title">
                          {performance.stockName ?? '—'}
                          {(lotVariant === 'MINI' || isMiniLot(performance.closing_order)) && (
                            <span className="lot-variant-mini">MINI</span>
                          )}
                        </span>
                    </h4>
                </div>
                <div className="position-card-pnl">
                    <p className={`position-pnl ${pnlColor}`}>₹{ pnlNum.toFixed(2) }</p>
                    <p className="position-price-range">{openPrice} >> {closePrice}</p>
                </div>
            </div>
            <div className="perf-stats">
                <div className="perf-stat">
                    <span className="perf-stat-label">Qty</span>
                    <span className={`perf-stat-value ${quantityColor}`}>
                        {isBuy ? '+' : '-'}{qtyValue}
                    </span>
                </div>
                <div className="perf-stat">
                    <span className="perf-stat-label">Side</span>
                    <span className={`perf-stat-value ${quantityColor}`}>
                        {isBuy ? 'Buy' : 'Sell'}
                    </span>
                </div>
                {typeLabel !== '' && (
                    <div className="perf-stat">
                        <span className="perf-stat-label">Type</span>
                        <span className={`perf-stat-value${isAutoExit ? ' red' : ''}`}>{typeLabel}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PerformanceCard;
